import type { RangeKey } from '../../../hooks/useBillingRange';
import type { MonitoringOverviewHistory } from '../../../services/dmMonitoringOverviewHistory';

export interface ReportingPeriod {
    // Card subtitle, e.g. "Last 7 days".
    label: string;
    // Ends the empty note, e.g. "in the last 7 days".
    phrase: string;
}

const RANGE_PERIODS: Readonly<Record<RangeKey, ReportingPeriod>> = {
    '7D': { label: 'Last 7 days', phrase: 'in the last 7 days' },
    '30D': { label: 'Last 30 days', phrase: 'in the last 30 days' },
    QTD: { label: 'Quarter to date', phrase: 'this quarter' },
    YTD: { label: 'Year to date', phrase: 'this year' },
    '12M': { label: 'Last 12 months', phrase: 'in the last 12 months' },
    All: { label: 'All time', phrase: 'yet' }
};

export function periodForRange(range: RangeKey): ReportingPeriod {
    return RANGE_PERIODS[range];
}

// What the range-driven cards render from; data is null until the first range loads.
export interface HistoryView {
    data: MonitoringOverviewHistory | null;
    failed: boolean;
    period: ReportingPeriod;
}

export type BreakdownMode = 'open' | 'range';

export const BREAKDOWN_MODE_OPTIONS: readonly { key: BreakdownMode; label: string }[] = [
    { key: 'open', label: 'Open' },
    { key: 'range', label: 'In range' }
];

export const OPEN_NOW_SUBTITLE = 'Open now';

export function breakdownSubtitle(mode: BreakdownMode, period: ReportingPeriod): string {
    return mode === 'open' ? OPEN_NOW_SUBTITLE : period.label;
}
